import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import {
  BInputGroup, BFormInput, BForm, BRow, BCol, BFormGroup, BFormSelect, BButton, BFormCheckboxGroup, BFormCheckbox, BProgress,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('b-row', BRow)
Vue.component('b-col', BCol)
Vue.component('b-form', BForm)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-input-group', BInputGroup)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-checkbox-group', BFormCheckboxGroup)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-button', BButton)
Vue.component('b-form-select', BFormSelect)
Vue.component('v-select', vSelect)
Vue.component('b-progress', BProgress)
